import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/Master'

/**
 * 運営サイト情報
 */
class Master extends BaseProcessor{
  static getClassName(){ return 'Master' }

  /**
   */
  static getFamilyRelation(input){
    return new Promise(function(resolve, reject) {
      API.getFamilyRelation(input)
        .then((res)=>{
          return resolve({status:"ok",data:{family_relations:res.family_relations} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }
}

export default Master



// WEBPACK FOOTER //
// ./src/processor/Master.js